<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/">展覽列表</a><span>/</span>
          <em name="Exhibition"></em> <span>/</span>電子邀請函專業展
        </div>
        <div>
          <span class="bold">登入帳號 :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div>
      <article>
        <div class="MbDevice">
          <div class="homeLeft">
            <div class="UserAccount ml-1">
              <span class="bold">登入帳號 :</span>
              <span> {{ UserId }}</span>
            </div>
            <hr />
            <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
            <div class="expoInfo">
              <p class="bold" name="Exhibition"></p>
              <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
              <p>{{ ExhVenue }}</p>
            </div>
            <p class="clear"></p>
          </div>
        </div>

        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span
                  class="font-weight-bold text-primary"
                  style="font-size: 16px"
                  v-if="item.MenuName == '電子邀請函'"
                >
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else>
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>
        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconInvite.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <!-- <div class="MbDevice ">
                        <h1> <img src="images/iconInvite.svg" width="35px" class="mb-1 ">
                            電子邀請函

                        </h1>
                    </div> -->

            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="@/assets/images/iconInvite.svg"
                      width="35px"
                      class="mt-1 mr-1"
                    />
                  </div>
                  <div>
                    <h1>電子邀請函</h1>
                  </div>
                </div>

                <!-- <div>
                  <h1><img src="@/assets/images/iconInvite.svg" width="35px" class="mb-2" /> 電子邀請函</h1>
                </div> -->
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="(item, index) in MenuInvitation"
                        :key="index"
                      >
                        <span class="MbListGray" @click="InviteLink(item.Url)">
                          {{ item.MenuName }}
                        </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>電子邀請函</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="mb-1">
              您可以產生專屬的電子邀請函EDM，並轉發EDM或複製EDM網址分享給您的大量客戶，受邀客戶完成EDM內「參觀資格開通」後，即可於展期憑「入場憑證
              QRcode」入場參觀。
            </p>

            <p class="my-3">&nbsp;</p>
            <ol class="number">
              <li>受邀客戶完成參觀資格開通後即列入額度使用計算</li>
              <li>如額度提前使用完畢，尚需更多額度請洽大會業務人員</li>
              <li>
                參觀邀請建議於展前
                <span class="red"><span name="CloseDay"></span> 23:59</span>
                前完成，以利客戶入場參觀
              </li>
              <li class="Caution">
                <span class="red"><span name="Caution"></span></span>
              </li>
            </ol>
            <p class="lightLine">&nbsp;</p>
            <h3>使用次數</h3>

            <p class="my-3">&nbsp;</p>
            <p>您可透過「使用次數」中的數字隨時掌握客戶開通之狀況。</p>

            <p class="my-3">&nbsp;</p>
            <div class="grayBG">
              <p>使用次數：<span name="InvitationUsed"></span></p>
            </div>
            <span class="OpenBothInvite">
              <p class="lightLine">&nbsp;</p>
              <h3>發送電子邀請函EDM</h3>

              <p class="my-3">&nbsp;</p>
              <p>
                歡迎「轉發電子邀請函」或「複製電子邀請函網址」分享邀請代碼給您的重要客戶！
              </p>
              <p class="my-3">&nbsp;</p>
              <!-- tw -->
              <div class="ShowPhyInvite">
                <h4 class="mb-4">
                  <span
                    style="
                      padding-bottom: 1px;
                      border-bottom: 1px solid rgb(0, 0, 0);
                    "
                  >
                    實體展邀請函
                  </span>
                </h4>
                <div class="left">
                  <div class="grayBG">
                    <p class="bold">實體展中文版邀請函</p>

                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <p name="Code"></p>
                        <input name="Code" class="hiddenInput" type="text" />
                        <p class="divider">&nbsp;</p>

                        <form
                          method="POST"
                          name="_method"
                          enctype="multipart/form-data"
                          action="/apiExhibitors/SendInvitationPreReg/"
                        >
                          <input type="hidden" name="RegNo" />
                          <input type="hidden" name="Lang" value="tw" />
                          <input type="hidden" name="eLang" value="tw" />
                          <div
                            class="btnStyle mr-2"
                            @click.prevent="SendRegMail('tw', 'Physical')"
                          >
                            發送中文版
                          </div>
                          <!-- <input type="submit" value="發送中文版" class="btnStyle"> -->
                          <input
                            type="button"
                            value="複製網址"
                            class="btnStyle copyURL"
                          />
                        </form>
                      </div>

                      <!-- <div>
                        <input type="button" value="複製網址" class="btnStyle copyURL" />
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- tw end -->
                <!-- en -->
                <div class="right">
                  <div class="grayBG">
                    <p class="bold">實體展英文版邀請函</p>

                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <p name="CodeEn"></p>
                        <input name="CodeEn" class="hiddenInput" type="text" />
                        <p class="divider">&nbsp;</p>
                        <form>
                          <input type="hidden" name="RegNo" />
                          <input type="hidden" name="Lang" value="tw" />
                          <input type="hidden" name="eLang" value="en" />
                          <div
                            class="btnStyle mr-2"
                            @click.prevent="SendRegMail('en', 'Physical')"
                          >
                            發送英文版
                          </div>
                          <input
                            type="button"
                            value="複製網址"
                            class="btnStyle copyURL"
                          />
                        </form>
                      </div>

                      <!-- <div>
                        <input type="button" value="複製網址" class="btnStyle copyURL" />
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <!-- en end -->
              <p class="clear"></p>
              <div class="ShowOnlineInvite">
                <h4 class="my-4">
                  <span
                    style="
                      padding-bottom: 1px;
                      border-bottom: 1px solid rgb(0, 0, 0);
                    "
                  >
                    線上展邀請函
                  </span>
                </h4>

                <div class="left">
                  <div class="grayBG">
                    <p class="bold">線上展中文版邀請函</p>

                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <p name="OnlineCode"></p>
                        <input
                          name="OnlineCode"
                          class="hiddenInput"
                          type="text"
                        />
                        <p class="divider">&nbsp;</p>
                        <form
                          method="POST"
                          name="_method"
                          enctype="multipart/form-data"
                          action="/apiExhibitors/SendInvitationPreReg/"
                        >
                          <input type="hidden" name="RegNo" />
                          <input type="hidden" name="Lang" value="tw" />
                          <input type="hidden" name="eLang" value="tw" />
                          <div
                            class="btnStyle mr-2"
                            @click.prevent="SendRegMail('tw', 'Online')"
                          >
                            發送中文版
                          </div>
                          <!-- <input type="submit" value="發送中文版" class="btnStyle"> -->
                          <input
                            type="button"
                            value="複製網址"
                            class="btnStyle copyURL"
                          />
                        </form>
                      </div>

                      <!-- <div>
                        <input type="button" value="複製網址" class="btnStyle copyURL" />
                      </div> -->
                    </div>
                  </div>
                </div>
                <!-- tw end -->
                <!-- en -->

                <div class="right">
                  <div class="grayBG">
                    <p class="bold">線上展英文版邀請函</p>

                    <div class="d-flex align-items-center">
                      <div class="mr-2">
                        <p name="OnlineCodeEn"></p>
                        <input
                          name="OnlineCodeEn"
                          class="hiddenInput"
                          type="text"
                        />
                        <p class="divider">&nbsp;</p>
                        <form>
                          <input type="hidden" name="RegNo" />
                          <input type="hidden" name="Lang" value="tw" />
                          <input type="hidden" name="eLang" value="en" />
                          <div
                            class="btnStyle mr-2"
                            @click.prevent="SendRegMail('en', 'Online')"
                          >
                            發送英文版
                          </div>
                          <input
                            type="button"
                            value="複製網址"
                            class="btnStyle copyURL"
                          />
                        </form>
                      </div>

                      <!-- <div>
                        <input type="button" value="複製網址" class="btnStyle copyURL" />
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </span>
          </div>
          <p class="clear"></p>
        </div>
      </article>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import axios from "axios";

export default {
  metaInfo() {
    return {
      title: "電子邀請函 - 展昭參展商管理系統",
    };
  },

  data() {
    return {
      UserId: "",
      CSRF_Token: "",
      RegNo: "",
      date: "",
      lang: "tw",
      openOnlineInvite: "",
      openPhyInvite: "",
      hasOnlineExh: "",
      hasPhyExh: "",
      MenuInvitation: [],
      ExhLogo: "",
      ExhBegin: "",
      ExhEnd: "",
      ExhVenue: "",
      eExhVenue: "",
    };
  },
  methods: {
    InviteLink(Url) {
      const vm = this;
      if (vm.lang == "tw") {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`;
      } else {
        document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`;
      }
    },
    SendRegMail(lang, type) {
      const vm = this;
      const url = `/apiExhibitors/SendInviteReg/`;
      const info = {
        CSRF: vm.CSRF_Token,
        E_Lang: lang,
        RegNo: vm.RegNo,
        Type: type,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        if (type == "Physical") {
          if (response.data.Code == 200) {
            alert(
              "實體展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。"
            );
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Email發生錯誤！");
          }
        } else if (type == "Online") {
          if (response.data.Code == 200) {
            alert(
              "線上展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。"
            );
          } else if (response.data.Code == 251 || response.data.Code == 500) {
            alert("系統忙碌，請稍後再試！");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Email發生錯誤！");
          }
        }
      });
    },

    SendRegMailEn(lang, type) {
      const vm = this;
      const url = `/apiExhibitors/SendInviteReg/`;
      const info = {
        CSRF: vm.CSRF_Token,
        E_Lang: lang,
        RegNo: vm.RegNo,
        Type: type,
      };

      // console.log(info)

      axios.post(url, info).then(function (response) {
        if (type == "Physical") {
          if (response.data.Code == 200) {
            alert(
              "Physical exhibition E-invitation has been sent to your email. You can send it to your VIP clients."
            );
          } else if (response.data.Code == 251) {
            alert("System is busy, please try again later.");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Email error！");
          } else if (response.data.Code == 500) {
            alert("System is busy, please try again later.");
          }
        } else if (type == "Online") {
          if (response.data.Code == 200) {
            alert(
              "Online exhibition E-invitation has been sent to your email. You can send it to your VIP clients."
            );
          } else if (response.data.Code == 251) {
            alert("System is busy, please try again later.");
          } else if (response.data.Code == 252) {
            document.location.href = `https://www.chanchao.com.tw/`;
          } else if (response.data.Code == 253) {
            alert("Email error！");
          } else if (response.data.Code == 500) {
            alert("System is busy, please try again later.");
          }
        }
      });
    },
  },

  created() {
    const vm = this;

    //取得語系

    let lang = "tw";

    //CSRF_Token
    axios
      .get("https://www.chanchao.com.tw/apiExhibitors/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    axios
      .get(`https://www.chanchao.com.tw/apiExhibitors/UserID`)
      .then((response) => {
        vm.UserId = response.data;
      });

    //url取出展碼
    let currentUrl = location.href;
    vm.RegNo = currentUrl.split("no=")[1];
    var RegNo = currentUrl.split("no=")[1];

    //取得當前時間
    let theDate = new Date();
    vm.date = `${theDate.getFullYear()}/${
      theDate.getMonth() + 1
    }/${theDate.getDate()}`;

    //取得是否開啟線上展權限
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`;
        vm.ExhBegin = response.data.Data.ExhBegin;
        vm.ExhEnd = response.data.Data.ExhEnd;
        vm.ExhVenue = response.data.Data.ExhVenue;
        vm.eExhVenue = response.data.Data.eExhVenue;

        vm.openOnlineInvite = response.data.Data.OnlineExpo_Archived;
        vm.openPhyInvite = response.data.Data.PhysicalExpo_Archived;

        //判定是否開放兩展邀請函

        if (vm.openOnlineInvite == 1 || vm.openPhyInvite == 1) {
          $(".OpenBothInvite").addClass("ShowInviteTopic");
          $(".OpenBothInvite").removeClass("HideInviteTopic");
        } else {
          $(".OpenBothInvite").addClass("HideInviteTopic");
          $(".OpenBothInvite").removeClass("ShowInviteTopic");
        }

        //取得是否有線上展
        axios
          .get(
            `https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`
          )
          .then((response) => {
            // console.log(response.data.Data)
            vm.hasOnlineExh = response.data.Data.Virtual;
            vm.hasPhyExh = response.data.Data.physical;

            //判定開放實體邀請函

            if (vm.openPhyInvite == 1 && vm.hasPhyExh == 1) {
              $(".ShowPhyInvite").addClass("ShowInviteTopic");
              $(".ShowPhyInvite").removeClass("HideInviteTopic");
            } else {
              $(".ShowPhyInvite").addClass("HideInviteTopic");
              $(".ShowPhyInvite").removeClass("ShowInviteTopic");
            }
            //判定開放線上展邀請函

            if (vm.openOnlineInvite == 1 && vm.hasOnlineExh == 1) {
              $(".ShowOnlineInvite").addClass("ShowInviteTopic");
              $(".ShowOnlineInvite").removeClass("HideInviteTopic");
            } else {
              $(".ShowOnlineInvite").addClass("HideInviteTopic");
              $(".ShowOnlineInvite").removeClass("ShowInviteTopic");
            }
          });
      });

    //取得邀請選單
    axios
      .get(
        `https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`
      )
      .then((response) => {
        // console.log(response.data.Data)

        vm.MenuInvitation = response.data.Data;
      });

    // $.ajaxSettings.async = false; //關閉非同步執行
    //RegNo

    $.getJSON(
      "/apiExhibitors/Exhibition/" + RegNo,
      { lang: lang },
      function (data) {
        //close day 展覽前一天23:59

        // console.log(data)

        var CloseDay = new Date(data.Data.ExhBegin);
        CloseDay.setDate(CloseDay.getDate() - 1);
        $('[name="CloseDay"]').text(formatDate(CloseDay));

        function formatDate(date) {
          var d = new Date(date),
            month = "" + (d.getMonth() + 1),
            day = "" + d.getDate(),
            year = d.getFullYear();
          if (month.length < 2) month = "0" + month;
          if (day.length < 2) day = "0" + day;
          return [year, month, day].join("/");
        }

        if (lang == "tw") {
          if (data.Data.Caution == "") {
            $(".Caution").addClass("HideCaution");
          } else {
            $(".Caution").addClass("ShowCaution");
            $('[name="Caution"]').text(data.Data.Caution);
          }
        } else {
          if (data.Data.eCaution == "") {
            $(".Caution").addClass("HideCaution");
          } else {
            $(".Caution").addClass("ShowCaution");
            $('[name="Caution"]').text(data.Data.eCaution);
          }
        }

        var OnlineExpoCode = data.Data.exhcode;
        if (OnlineExpoCode == "9864D87B9B73E6DE48B0D75EE3475027") {
          $(".laserExpo").addClass("ShowlaserExpo");
          $(".laserExpo").removeClass("HidelaserExpo");
        } else {
          // console.log('none')
        }

        //get Exhibitor data
        $.getJSON("/apiExhibitors/Exhibitor/" + RegNo, function (data) {
          // console.log(data)
          var Company_Code = data.Data.Company_Code;
          var AppNo = data.Data.AppNo;

          //get invitation data
          $.getJSON(
            "/apiExhibitors/InvitationPreReg/" + RegNo,
            function (data) {
              // console.log(data.Data)
              $('[name="InvitationUsed"]').text(data.Data.InvitationUsed); //已使用

              //tw URL
              let Code =
                "https://www.chanchao.com.tw/visitorInvitation/edm_reg.asp?code=" +
                Company_Code +
                "&sno=" +
                AppNo;
              $('[name="Code"]').text(Code).val(Code);
              //en URL
              let CodeEn =
                "https://www.chanchao.com.tw/en/visitorInvitation/edm_reg.asp?code=" +
                Company_Code +
                "&sno=" +
                AppNo;
              $('[name="CodeEn"]').text(CodeEn).val(CodeEn);

              //online tw URL

              let OnlineCode =
                "https://www.chanchao.com.tw/visitorInvitation/edm_reg_onlineexpo.asp?code=" +
                Company_Code +
                "&sno=" +
                AppNo +
                "&rno=" +
                RegNo;
              $('[name="OnlineCode"]').text(OnlineCode).val(OnlineCode);

              //online en URL

              let OnlineCodeEn =
                "https://www.chanchao.com.tw/en/visitorInvitation/edm_reg_onlineexpo.asp?code=" +
                Company_Code +
                "&sno=" +
                AppNo +
                "&rno=" +
                RegNo;
              $('[name="OnlineCodeEn"]').text(OnlineCodeEn).val(OnlineCodeEn);
            }
          );
        });

        //copy edm URL
        $(".copyURL").click(function () {
          let copyText = $(this).parent().parent().find(".hiddenInput");
          copyText.select();
          document.execCommand("Copy");

          if (vm.lang == "tw") {
            alert("網址已複製");
          } else {
            alert("URL copied");
          }
        });
      }
    );
    // $.ajaxSettings.async = true; //開啟非同步執行
  },
};
</script>

<style lang="scss"></style>
